import { observer } from 'mobx-react-lite'
import { useCallback, useEffect, useState } from 'react'
import { StyleSheet, View } from 'react-native'
import { useStore } from '../../../../../models'
import { ProgressBar } from '../../../ProgressBar'
import { DS } from '../../../../../design-system'

type TimerProps = {
  playerActionTimerExpired: boolean
  actionTime: number
  secondsPassed: number
}

const Timer = ({ playerActionTimerExpired, actionTime, secondsPassed }: TimerProps) => {
  const [timeLeft, setTimeLeft] = useState(Math.floor((actionTime - secondsPassed) / 1000))
  // Purely visual countdown timer in top-left corner.
  useEffect(() => {
    const interval = setInterval(() => {
      if (playerActionTimerExpired) {
        setTimeLeft(0)
      } else if (timeLeft > 0) {
        setTimeLeft(timeLeft - 1)
      }
    }, 1000)
    return () => clearInterval(interval)
  }, [timeLeft, playerActionTimerExpired])

  return (
    <DS.Frame row justifyContent={'space-between'}>
      <DS.Text variant="Caption/Bold" uppercase>
        Place your bet
      </DS.Text>
      <DS.Text variant="Caption/Medium">{timeLeft}s left</DS.Text>
    </DS.Frame>
  )
}

export const BetModalTop = observer(({ error }: { error: string }) => {
  const {
    game: {
      actionTime,
      lastActiveCheckpoint,
      modals: { playerActionTimerExpired, setPlayerActionTimerExpired }
    }
  } = useStore()

  const secondsPassed = Date.now() - lastActiveCheckpoint

  const onComplete = useCallback(() => {
    setPlayerActionTimerExpired(true)
  }, [setPlayerActionTimerExpired])

  return (
    <DS.Frame style={styles.container}>
      <Timer
        playerActionTimerExpired={playerActionTimerExpired}
        actionTime={actionTime}
        secondsPassed={secondsPassed}
      />
      <View style={styles.progressBar}>
        <ProgressBar
          duration={actionTime - secondsPassed}
          maxDuration={actionTime}
          backgroundColor={'Global/Black'}
          backgroundOpacity={0.1}
          color={'Brand/Orange'}
          onComplete={onComplete}
        />
      </View>
      <DS.Frame justifyContent={'center'} style={styles.errorContainer}>
        {error ? (
          <DS.Text variant="Mini/Medium" color="Utility/Warning">
            {error}
          </DS.Text>
        ) : null}
      </DS.Frame>
    </DS.Frame>
  )
})

const styles = StyleSheet.create({
  container: {
    justifyContent: 'space-between',
    width: '100%',
    height: '10%'
  },
  progressBar: {
    width: '100%',
    marginTop: 8
  },
  errorContainer: {
    width: '100%',
    alignItems: 'center',
    height: 12
  }
})
